/**
 * 检测任务api
 * date:2022 05 09
 */
import httpRequest from '@/utils/request.js';

/**获取检测任务列表 */
export const taskList = (params = {}) => httpRequest.httpGet({
    url: '/service/task/detection/page', params: {
        ...params
    }
});
/**获取检测详细 */
export const taskDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/task/detection/detail', params: {
        ...params
    }
});

/**获取检测添加 */
export const taskAdd = (data) => httpRequest.httpPost('/service/task/detection/add', data)

/**获取检测修改 */
export const taskUpdate = (data) => httpRequest.httpPut('/service/task/detection/update', data)

/**获取检测删除 */
export const taskDelete = (data) => httpRequest.httpdelete2('/service/task/detection/delete', data)

/**获取任务内容列表 */
export const taskContent = (params = {}) => httpRequest.httpGet({
    url: '/service/task/detection/content', params: {
        ...params
    }
});
/**启动执行一次 */
export const taskOnce = (params = {}) => httpRequest.httpGet({
    url: '/service/task/detection/run/once', params: {
        ...params
    }
});
/**启动 */
export const taskRun = (data) => httpRequest.httpPut2('/service/task/detection/run', data);
/**停止 */
export const taskStop = (data) => httpRequest.httpPut2('/service/task/detection/stop', data);